import './styles.css';

import React from 'react';
import { Typography } from '@vtblife/uikit';
import { TypographyProps } from '@vtblife/uikit/dist/components/typography/types';

import { TransportType } from '@search/filter-enums/enums/TransportType';
import classname from '@search/classname/src';

import { OfferRoute } from '../../../../domain/offer/search/page/SearchOffersQuery';
import { SubwayStation } from '../SubwayStation';
import { IconBus } from './IconBus';
import { IconPedestrian } from './IconPedestrian';

const cn = classname.bind(null, 'OfferRouteCard');

interface OfferRouteCardProps {
    offerRoute: OfferRoute;
    className?: string;
    variant?: TypographyProps['variant'];
    noClickable?: boolean;
    withoutTime?: boolean;
}

export const OfferRouteCard = ({
    offerRoute,
    className,
    variant = 'primary',
    noClickable,
    withoutTime = false
}: OfferRouteCardProps) => {
    return (
        <div className={cn(null, undefined, className)}>
            <SubwayStation
                textVariant={variant}
                station={offerRoute.metro}
                noClickable={noClickable}
                url={offerRoute.url}
            />
            {! withoutTime && Boolean(offerRoute.timeMinutes) && (
                <OfferRouteTimeCard
                    variant={variant}
                    offerRoute={offerRoute}
                />
            )}
        </div>
    );
};

const cnTime = classname.bind(null, 'OfferRouteTimeCard');

const OfferRouteTimeCard = ({
    offerRoute,
    variant
}: {
    offerRoute: OfferRoute;
    variant: TypographyProps['variant'];
}) => {
    let icon: React.ReactElement | undefined;

    if (offerRoute.transportType === TransportType.FOOT) icon = <IconPedestrian />;
    if (offerRoute.transportType === TransportType.PUBLIC_TRANSPORT) icon = <IconBus />;

    return (
        <div className={cnTime()}>
            <div className={cnTime('icon')}>
                {icon}
            </div>
            <Typography variant={variant} color='secondary'>
                {offerRoute.timeMinutes} мин.
            </Typography>
        </div>
    );
};
